import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MaterialButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const circularSize = {
    large: 18,
    medium: 14,
    small: 12
};

function loader(loading, size, color) {
    return (
        loading && (
            <CircularProgress
                className="NeptuneButton-loader"
                size={circularSize[size || 'medium']}
                color={color}
            />
        )
    );
}

const Button = forwardRef(({ loading, children, ...props }, ref) => {
    const attrs = { ref };

    return (
        <MaterialButton {...attrs} {...props}>
            {loader(loading, props.size, props.color)}
            {children}
        </MaterialButton>
    );
});

Button.displayName = 'NeptuneButton';

Button.propTypes = {
    ...MaterialButton.propTypes,
    loading: PropTypes.bool
};

Button.defaultProps = {
    ...MaterialButton.defaultProps,
    loading: null
};

export default Button;
